import * as React from 'react';
import { storyblokEditable, StoryblokComponent, type SbBlokData } from '@storyblok/react';

import type { PageStoryblok } from '../../types/storyblok';

interface PageProps {
  blok: PageStoryblok;
}

// Page is the root content type. It renders an array of child bloks via
// <StoryblokComponent>, which resolves each child's `component` field through
// the registry registered in src/storyblok/init.ts (task 4.2).
// Note: Header is rendered globally via Layout component (see gatsby-browser/ssr.js)
export const Page: React.FC<PageProps> = ({ blok }) => {
  return (
    <main {...storyblokEditable(blok as unknown as SbBlokData)}>
      {blok.body?.map((child) => (
        <StoryblokComponent key={child._uid} blok={child as unknown as SbBlokData} />
      ))}
    </main>
  );
};
